import { getAPIendpointPrefix } from './apiHelper.js'

import {
  LOAD_PROGRESS_REQUEST,
  LOAD_PROGRESS_SUCCESS,
  LOAD_PROGRESS_FAILURE
} from '../actions'
import { axios } from '../../shared/lib/axios'

export default ({ userId, userIdType = 'arga', assignmentId }) => {
  return async (dispatch, getState) => {
    dispatch({ type: LOAD_PROGRESS_REQUEST })

    const { core: { consul: { LC_GRADE_SERVICE_URL, FF_USE_LC_GRADE_SERVICE }}} = getState();
    const apiEndpoint = FF_USE_LC_GRADE_SERVICE === 'true' ? `${LC_GRADE_SERVICE_URL}/` : getAPIendpointPrefix()

    const endpoint = apiEndpoint + 'api/v1/student_progress' +
      `?user_id=${userId}&user_id_type=${userIdType}` +
      `&assignment_id=${assignmentId}`

    try {
      let data
      const response = await axios.get(endpoint)
      const contentType = response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        data = response.data.activity_state;
      } else {
        data = response.statusText;
      }
      dispatch({ type: LOAD_PROGRESS_SUCCESS, payload: data })
      return data;
    } catch (err) {
      console.error(err);
      dispatch({ type: LOAD_PROGRESS_FAILURE, payload: err })
    }
  }
}
